import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Categories20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.8838 1.32321C10.3957 0.835054 9.6042 0.835053 9.11604 1.32321L5.57315 4.8661C5.08499 5.35426 5.08499 6.14571 5.57315 6.63387L9.11604 10.1768C9.6042 10.6649 10.3957 10.6649 10.8838 10.1768L14.4267 6.63387C14.9149 6.14571 14.9149 5.35426 14.4267 4.8661L10.8838 1.32321ZM6.81058 5.74998L9.99992 2.56065L13.1893 5.74998L9.99992 8.93932L6.81058 5.74998Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.75 14.5C0.75 12.1528 2.65279 10.25 5 10.25C7.34721 10.25 9.25 12.1528 9.25 14.5C9.25 16.8472 7.34721 18.75 5 18.75C2.65279 18.75 0.75 16.8472 0.75 14.5ZM5 11.75C3.48122 11.75 2.25 12.9812 2.25 14.5C2.25 16.0188 3.48122 17.25 5 17.25C6.51878 17.25 7.75 16.0188 7.75 14.5C7.75 12.9812 6.51878 11.75 5 11.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.6512 10.6279L19.6512 17.6279C19.9317 18.1187 19.5653 18.75 19 18.75H11C10.4347 18.75 10.0683 18.1187 10.3488 17.6279L14.3488 10.6279C14.6314 10.1333 15.3686 10.1333 15.6512 10.6279ZM17.7076 17.25L15 12.5117L12.2924 17.25H17.7076Z'
      fill='currentColor'
    />
  </Svg>
);

Categories20.displayName = 'Categories20';
export default Categories20;
